export default "__VITE_ASSET__4902b146__"